(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["brand-language-picker"] && !Shopify.designMode) return;
  try {
    /* Close the language list on a click outside it or on Escape. */
  (() => {
    const closeAll = (except) => {
      for (const picker of document.querySelectorAll('.brand-lang[open]')) {
        if (picker !== except) picker.removeAttribute('open');
      }
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      closeAll(event.target.closest('.brand-lang'));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = document.querySelector('.brand-lang[open]');
      if (!open) return;
      open.removeAttribute('open');
      open.querySelector('summary')?.focus();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
